/**
 * Deterministic gradient avatar from a wallet address or seed string.
 * Same algorithm as the OG image generator — produces a colorful
 * linear gradient that matches the trader's OG preview card.
 */

function generateGradient(seed: string): { backgroundColor: string; backgroundImage: string } {
  let h = 0;
  for (let i = 0; i < seed.length; i++) {
    h = seed.charCodeAt(i) + ((h << 5) - h);
    h = h & h;
  }
  const abs = (n: number) => (n < 0 ? -n : n);

  const color = (offset: number) => {
    const r = abs((h >> (offset * 3)) * 997) % 256;
    const g = abs((h >> (offset * 3 + 1)) * 991) % 256;
    const b = abs((h >> (offset * 3 + 2)) * 983) % 256;
    return `rgb(${r}, ${g}, ${b})`;
  };

  const angle = abs((h >> 0) * 761) % 360;

  return {
    backgroundColor: color(0),
    backgroundImage: `linear-gradient(${angle}deg, ${color(1)} 0%, ${color(2)} 35%, ${color(3)} 65%, ${color(4)} 100%)`,
  };
}

interface GradientAvatarProps {
  seed: string;
  size?: number;
  className?: string;
}

export default function GradientAvatar({
  seed,
  size = 44,
  className = "",
}: GradientAvatarProps) {
  const gradient = generateGradient(seed);

  return (
    <div
      className={`rounded-[5px] shrink-0 ${className}`}
      style={{
        width: size,
        height: size,
        backgroundColor: gradient.backgroundColor,
        backgroundImage: gradient.backgroundImage,
      }}
    />
  );
}

export { generateGradient };
